import { axiosInstance } from '../Axios';

const { createSlice } = require('@reduxjs/toolkit');

const BannerReducer = createSlice({
	name: 'banner',
	initialState: {
		success: false,
		error: null,
		loading: false,
		banner: null,
	},
	reducers: {
		bannerRequest(state, action) {
			state.loading = true;
		},
		bannerSuccess(state, action) {
			state.loading = false;
			state.banner = action.payload;
			state.error = null;
		},
		bannerFail(state, action) {
			state.loading = false;
			state.error = action.payload;
		},
	},
});

const { actions } = BannerReducer;

export const { bannerRequest, bannerSuccess, bannerFail } = actions;

export const fetchBannerDispatch = () => async (dispatch) => {
	try {
		dispatch(bannerRequest());
		const { data } = await axiosInstance.get('/app/api/banners');
		console.log(data);
		dispatch(bannerSuccess(data));
	} catch (error) {
		dispatch(
			bannerFail(
				error.response && error.response.data.message
					? error.response.data.message
					: error.message
			)
		);
	}
};

export default BannerReducer;
